import { render } from "./AposTiptapImportTable.vue?vue&type=template&id=6e81cc18"
import script from "./AposTiptapImportTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AposTiptapImportTable.vue?vue&type=script&setup=true&lang=js"

import "./AposTiptapImportTable.vue?vue&type=style&index=0&id=6e81cc18&lang=scss"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"rich-text-widget/ui/apos/components/AposTiptapImportTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e81cc18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e81cc18', __exports__)) {
    api.reload('6e81cc18', __exports__)
  }
  
  module.hot.accept("./AposTiptapImportTable.vue?vue&type=template&id=6e81cc18", () => {
    api.rerender('6e81cc18', render)
  })

}


export default __exports__